export enum Step {
  NOVO = 'NOVO',
  LIMPEZA = 'LIMPEZA',
  PINTURA = 'PINTURA',
  EMBALAGEM = 'EMBALAGEM',
  CONCLUIDO = 'CONCLUIDO',
  ENTREGUE = 'ENTREGUE',
}
